// StatisticaGroupsAttends.jsx
import React, { useState, useEffect } from 'react';
import { kindergartenActions } from './actions';
import { monthUa, ukrDaysName, holyDaysEvery, groupTypes, TYPE_SANAORNIY, normalPlaceForGorups } from './constants';
import Filters from './Filters';
import './StatisticaGroupsAttends.css';


const getComplArr = (arr1, arr2) => {
  const newArr = [...arr1];
  arr2.forEach(a2 => {
    if (!newArr.includes(a2)) newArr.push(a2);
  });
  return newArr;
};

const getHolidays = (date_to) => {
  const [days, year, month] = [date_to.getDate(), date_to.getFullYear(), date_to.getMonth()];
  const weekHolidays = [];
  
  for (let i = 1; i <= days; i++) {
    const day = new Date(year, month, i).getDay();
    if ([0, 6].includes(day)) weekHolidays.push(i);
  }
  
  return getComplArr(weekHolidays, holyDaysEvery[month]);
};

const StatisticaGroupsAttends = () => {
  const [state, setState] = useState({
    years: [],
    setDistr: [],
    setSpec: [],
    selYear: '',
    selMonth: 'none',
    selDist: 'all',
    selSpec: 'all',
    selAge: 'all',
    infoGr: [],
    numbWorkDays: 0,
    grFull: [],
    arrTypes: {},
    showComponent: null
  });

  

  useEffect(() => {
    initializeComponent();
  }, []);

  const initializeComponent = () => {
    const typesGr = {};
    groupTypes.forEach((item) => {
      let ageFrom = item.ageLimitFrom;
      if (item && item.ageLimitFromPlusMonth) ageFrom += item.ageLimitFromPlusMonth / 12;
      typesGr[item.number] = ageFrom + '-' + item.ageLimitTo;
    });

    setState(prev => ({
      ...prev,
      grFull: groupTypes,
      arrTypes: typesGr
    }));

    handleGetPeriodYearsAndDistricts();
  };

  const handleGetPeriodYearsAndDistricts = async () => {
    try {
      const res = await kindergartenActions.getPeriodYearsAndDistricts();
      
      if (res.data?.cursor?.length > 0) {
        const updatedYears = res.data.cursor.map(year => {
          const distr = new Set();
          let solPresent = false;
          
          year.dist.forEach(dist => {
            if (!dist.match(/Со/)) {
              distr.add(dist);
            } else {
              solPresent = true;
            }
          });

          if (solPresent) {
            distr.add('Солом’янський');
          }

          return {
            ...year,
            dist: Array.from(distr).sort()
          };
        });

        const firstYear = updatedYears[0];
        setState(prev => ({
          ...prev,
          years: updatedYears,
          setDistr: firstYear.dist,
          setSpec: firstYear.specializations?.sort() || [],
          selYear: `${firstYear._id}:0`,
          selDist: firstYear.dist.sort()[0]
        }));
      } else {
        setState(prev => ({ 
          ...prev, 
          showComponent: <div className="text-center">Не має інформації в обраному періоді</div> 
        }));
      }
    } catch (error) {
      console.error('Error fetching years and districts:', error);
      setState(prev => ({ 
        ...prev, 
        showComponent: <div className="text-center">Помилка завантаження даних</div> 
      }));
    }
  };

  const handleGetInfoAboutGroups = async () => {
    if (state.selMonth === 'none') {
      alert('Будь ласка, оберіть місяць');
      return;
    }

    const yearPart = state.selYear.split(':')[0];
    const dateFrom = state.selMonth > 7 ?
      new Date(+yearPart, +state.selMonth, 1, 3, 0, 0) :
      new Date(+yearPart + 1, +state.selMonth, 1, 3, 0, 0);

   

    const dateTo = state.selMonth !== 11 ?
      new Date(dateFrom.getFullYear(), +state.selMonth + 1, 0, 23, 59, 59) :
      new Date(dateFrom.getFullYear() + 1, 0, 0, 23, 59, 59);

    const numbWorkDays = dateTo.getDate() - getHolidays(dateTo).length;

    const params = {
      year: yearPart,
      date_to: dateTo.toISOString(),
      date_from: dateFrom.toISOString()
    };

    if (state.selDist !== 'all') params.distr = state.selDist;
    if (state.selSpec !== 'all') params.spec = state.selSpec;
    if (state.selAge !== 'all') params.age_type = state.selAge;

    try {
      const res = await kindergartenActions.getInfoAboutGroups(params);
      
      if (res.data?.cursor?.length > 0) {
        const updatedCursor = res.data.cursor.map(el => ({
          ...el,
          groups: el.groups.map(group => ({
            ...group,
            attend: {
              ...group.attend,
              days: Array.from(new Set(group.attend.days.map(day => 
                day.split('T').length === 2 ? day.split('T')[0] : day
              )))
            }
          }))
        }));

        setState(prev => ({
          ...prev,
          infoGr: updatedCursor,
          numbWorkDays,
          showComponent: renderTableInfo(updatedCursor, numbWorkDays)
        }));
      } else {
        setState(prev => ({ 
          ...prev, 
          showComponent: <div className="text-center">Не має інформації в обраному періоді</div> 
        }));
      }
    } catch (error) {
      console.error('Error fetching groups info:', error);
      setState(prev => ({ 
        ...prev, 
        showComponent: <div className="text-center">Помилка завантаження даних</div> 
      }));
    }
  };

  const handleUpdateReservedPlaces = async (kgId) => {
    try {
      const res = await kindergartenActions.updateReservedPlaces(kgId);
      return res;
    } catch (error) {
      console.error('Error updating reserved places:', error);
      throw error;
    }
  };

  const handleSetReserv = async (kgId) => {
    try {
      const res = await kindergartenActions.setReserv(kgId);
      return res;
    } catch (error) {
      console.error('Error setting reserv:', error);
      throw error;
    }
  };

  const handleYearChange = (e) => {
    const [yearId, index] = e.target.value.split(':');
    const selectedYear = state.years[index];
    
    let distr = [];
    let countSol = 0;

    selectedYear.dist.forEach(item => {
      if (item.match(/Со/) && countSol === 0) {
        countSol += 1;
        distr.push('Солом\'янський');
      } else {
        distr.push(item);
      }
    });

    setState(prev => ({
      ...prev,
      setDistr: distr.sort(),
      selYear: e.target.value,
      setSpec: selectedYear.specializations?.sort() || [],
      selDist: distr.sort()[0]
    }));
  };

  const handleFilterChange = (key, value) => {
    setState(prev => ({ ...prev, [key]: value }));
  };

  const renderTableInfo = (infoGr, numbWorkDays) => {

    if(!infoGr || !numbWorkDays) return <></>;

      let res = {
            kg:0,
            ngr:0,
            numbPlaces:0,
            numbPlacesPlan:0,
            numberChildrens:0,
            numberRezerv:0,
            numberAttendYasly:0,
            numberAttend:0,
            numberAttendsCount:0,
            numberAttendDays:0,
            numberChildrensYasli:0,
            numbPlacesInc: 0,
            numbPlacesShrt: 0
        };




    return (
      <div className="table-container">
        <div className="text-center">
          <p className="reg-title">
            Інформація про відвідування за {monthUa[state.selMonth]} {state.selMonth > 7 ? state.selYear.split(':')[0] : +state.selYear.split(':')[0] + 1} року
          </p>
          <p>кількість робочих днів - {numbWorkDays}</p>
        </div>
        
        {false && <div style={{ float: 'right', cursor: 'pointer' }}>
          <span title="скопіювати таблицю для ексел">
            <img 
              src='/img/exell_download_icon_48x48.png' 
              className="copy-icon"
              alt="Copy to Excel"
              onClick={() => console.log('Copy functionality')} 
            />
          </span>
        </div>}

        <div className="table-responsive table-fix-head">
          <table className="table table-striped">
            <thead>
              <tr>
                <th scope="col">№</th>
                <th scope="col">ЗДО</th>
                <th scope="col">Район</th>
                <th scope="col">Груп</th>
                <th scope="col">Дітей яслі</th>
                <th scope="col">Дітей разом</th>
                <th scope="col">В.яслі кіл.</th>
                <th scope="col">В.яслі %</th>
                <th scope="col">В.разом кіл.</th>
                <th scope="col">В.разом сп. %</th>
                <th scope="col">В.разом н. %</th>
                <th scope="col">Дитиноднів</th>
                <th scope="col">Відмічено днів</th>
                <th scope="col">Спеціалізація</th>
                <th scope="col">Вікові категорії</th>
              </tr>
            </thead>
            <tbody>
              {infoGr.map((item, i) => {
                
                    let numbPlaces = 0;
                    let numbPlacesPlan = 0;
                    let specialization = {};
                    let numberChildrens = 0;
                    let typesGroup = {};
                    let styleColor = {};
                    let numberAttend = 0;
                    let numberAttendsCount = 0;
                    let numberAttendYasly = 0;
                    let numberChildrensYasli = 0;
                    let  numbPlacesInc = 0;
                    let numbPlacesShrt = 0;
                    const all_days = {};
                    let normalNumberChildrensYasli = 0;
                    let normalNumberChildrens = 0;

                    let days_arr = [];


                    res['kg'] +=1;

                item.groups.map( (elem) => {
                  Object.keys(elem.number_site).map( (places) => {
                      numbPlaces += elem.number_site[places];
                  } );

                  if(elem.planed_site) Object.keys(elem.planed_site).map( (places) => {
                      numbPlacesPlan += elem.planed_site[places];
                  } );


                  numbPlacesInc += elem.number_site.inclusive;
                  numbPlacesShrt += elem.number_site['withoutBeds'];

                  if( elem.spec != 'без спеціалізації') specialization[elem.spec] += 1;

                  if( elem.spec != 'без спеціалізації' && elem.specifics != TYPE_SANAORNIY) {
                      
                      if(elem.type === 1 || elem.type === 2 || elem.type === 3 || elem.type === 9 || elem.type === 13 || elem.type === 14) {
                          normalNumberChildrensYasli += normalPlaceForGorups.spec.hasOwnProperty(elem.spec) ? normalPlaceForGorups.spec[elem.spec] : normalPlaceForGorups.spec.default;
                      }
                      normalNumberChildrens +=  normalPlaceForGorups.spec.hasOwnProperty(elem.spec) ? normalPlaceForGorups.spec[elem.spec] : normalPlaceForGorups.spec.default;

                  }
                  if( elem.spec == 'без спеціалізації' && elem.specifics != TYPE_SANAORNIY) {

                      if(elem.type === 1 || elem.type === 2 || elem.type === 3 || elem.type === 9 || elem.type === 13 || elem.type === 14) {
                          normalNumberChildrensYasli += normalPlaceForGorups.wo_spec.hasOwnProperty(elem.type) ? normalPlaceForGorups.wo_spec[elem.type] : normalPlaceForGorups.wo_spec.default;
                      }
                      
                      normalNumberChildrens +=  normalPlaceForGorups.wo_spec.hasOwnProperty(elem.type) ? normalPlaceForGorups.wo_spec[elem.type] : normalPlaceForGorups.wo_spec.default;


                  }

                  if( elem.specifics == TYPE_SANAORNIY ) {
                      if(elem.type === 1 || elem.type === 2 || elem.type === 3 || elem.type === 9 || elem.type === 13 || elem.type === 14) {
                          normalNumberChildrensYasli += normalPlaceForGorups.sanat[14];
                      }
                      normalNumberChildrens +=  normalPlaceForGorups.sanat.hasOwnProperty(elem.type) ? normalPlaceForGorups.sanat[elem.type] : normalPlaceForGorups.sanat.default;                   
                  }

                  typesGroup[elem.type] +=1;


                  elem.info.map( (ch) => {
                      numberChildrens += ch.numb_ch;

                      if(elem.type === 1 || elem.type === 2 || elem.type === 3 || elem.type === 9 || elem.type === 13 || elem.type === 14) {
                          numberChildrensYasli += ch.numb_ch;
                      }

                  } )

                

                  if(elem.type === 1 || elem.type === 2 || elem.type === 3 || elem.type === 9 || elem.type === 13 || elem.type === 14) {
                      numberAttendYasly += +elem.attend.count;
                  }

                  numberAttend += +elem.attend.count;
                  elem.attend.days.forEach(d=>{if(!all_days[d]) all_days[d] = 0; all_days[d] += 1});

                  days_arr.push([...elem.attend.days])
            } )


            const numberAttendDays = Object.keys(all_days).length;


            if (Object.keys(specialization).length == 0 ) specialization['не має'] = 1;

            const numbRes = item.groups.reduce( (accumulator, currentValue) => accumulator + currentValue.reserv.length, 0 );

            res['ngr'] += item.groups.length;
            res['numbPlaces'] += numbPlaces;
            res['numbPlacesPlan'] += numbPlacesPlan;
            res['numberChildrens'] += numberChildrens;
            res['numberRezerv'] += numbRes;
            res['numberAttend'] += numberAttend;
            res['numberAttendsCount'] += numberAttend;
            res['numberAttendDays'] += numberAttendDays;
            res['numberAttendYasly'] += numberAttendYasly;
            res['numberChildrensYasli'] += numberChildrensYasli;
            res['numbPlacesInc'] +=  numbPlacesInc;
            res['numbPlacesShrt'] += numbPlacesShrt;


            numberAttendsCount = numberAttend;

            numberAttend = +((numberAttend / state.numbWorkDays).toFixed(0));
            numberAttendYasly = +((numberAttendYasly / state.numbWorkDays).toFixed(0));


           

            switch (true) {
                case (numberAttendDays < state.numbWorkDays):
                    styleColor = { 'color': 'red'};
                    break;
                case (numberAttendDays === state.numbWorkDays):
                    styleColor = { 'color': 'green'};
                    break;
                case (numberAttendDays > state.numbWorkDays):
                    styleColor = { 'color': 'blue'};
                    break;
            }

               
            const attendDaysTitle = '';

            //const attendDaysTitle =  (
           //   numberAttendDays > 0 ? '+ ' + days_arr.join(';') + ';' : '')  + (Object.keys(item.attend.dless).length > 0 ? ' - ' + (Object.keys(item.attend.dless)).join(';'):'');
                


                
                return(
                <tr key={i}>
                  <td>{i + 1}</td>
                  <td>{item._id?.number || 'Н/Д'}</td>
                  <td>{item._id?.distr || 'Н/Д'}</td>
                  <td>{item.groups?.length || 0}</td>
                  <td>{numberChildrensYasli}</td>
                  <td>{numberChildrens}</td>
                  <td>{numberAttendYasly}</td>
                  <td>{normalNumberChildrensYasli > 0 ? (numberAttendYasly/ normalNumberChildrensYasli*100).toFixed(0) : 0}%</td>
                  <td>{numberAttend}</td>
                  <td>{numberChildrens > 0 ? (numberAttend/numberChildrens*100).toFixed(0) : 0 }%</td>
                  <td>{normalNumberChildrens > 0 ? (numberAttend/normalNumberChildrens*100).toFixed(0) : 0 }%</td>
                  <td>{numberAttendsCount}</td>
                  <td style={styleColor} title= {attendDaysTitle} >{numberAttendDays}</td>
                  <td>{ Object.keys(specialization).join(', ') }</td>
                  <td>{ Object.keys(typesGroup).map((item)=>state.arrTypes[item]).join(', ') }</td>
                </tr>
              )}
              )}
            </tbody>
          </table>
        </div>
      </div>
    );
  };

  return (
    <div className="statistica-container attends-statistic">
      <Filters
        years={state.years}
        setDistr={state.setDistr}
        setSpec={state.setSpec}
        selYear={state.selYear}
        selMonth={state.selMonth}
        selDist={state.selDist}
        selSpec={state.selSpec}
        selAge={state.selAge}
        grFull={state.grFull}
        onYearChange={(e) => handleYearChange(e)}
        onMonthChange={(e) => handleFilterChange('selMonth', e.target.value)}
        onDistChange={(e) => handleFilterChange('selDist', e.target.value)}
        onSpecChange={(e) => handleFilterChange('selSpec', e.target.value)}
        onAgeChange={(e) => handleFilterChange('selAge', e.target.value)}
        onShowData={handleGetInfoAboutGroups}
      />

      {renderTableInfo(state.infoGr, state.numbWorkDays)}
    </div>
  );
};

export default StatisticaGroupsAttends;